import { useState } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { v4 } from 'uuid'

import Icon from '@/components/Icon/Icon'
import { useTheme } from '@/components/ThemeProvider/ThemeProvider'
import { SET_ADDITIONAL_FILTERS } from '@/store/cardlists/actions/types'
import { useActionless, useAppSelector } from '@/store/hooks'
import { DEFAULT_FILTER_VALUE, DEFAULT_FILTER_VALUE_MAP } from '@/types/additionalFilters'

type TooltipWrapperProps = {
  children: React.ReactElement
  show: boolean
}

const TooltipWrapper = ({ children, show }: TooltipWrapperProps) =>
  show ? <OverlayTrigger overlay={<Tooltip>Filter these results</Tooltip>}>{children}</OverlayTrigger> : <>{children}</>

const AdditionalFiltersButton = () => {
  const filters = useAppSelector((state) => state.cardlists.additionalFilterRows)
  const [setFilters] = useActionless(SET_ADDITIONAL_FILTERS)
  const [showDropdown, setShowDropdown] = useState(false) // Manually control dropdown visibility so we can hide the tooltip
  const [theme] = useTheme()

  const changeFilter = (filter: keyof typeof DEFAULT_FILTER_VALUE_MAP, i: number) => {
    const newValues = DEFAULT_FILTER_VALUE_MAP[filter] || DEFAULT_FILTER_VALUE
    setFilters([
      ...filters.slice(0, i),
      {
        key: v4(),
        type: filter,
        values: newValues,
      },
      ...filters.slice(i + 1),
    ])
  }

  return (
    <TooltipWrapper show={!showDropdown}>
      <DropdownButton
        className='ml-2'
        onSelect={(e) => changeFilter(e as unknown as keyof typeof DEFAULT_FILTER_VALUE_MAP, filters.length + 1)}
        onToggle={(nextShow) => setShowDropdown(nextShow)}
        show={showDropdown}
        size='sm'
        title={<Icon icon='filter' />}
        variant={theme}
      >
        <Dropdown.Item eventKey='cardName'>Card Name</Dropdown.Item>
        <Dropdown.Item eventKey='typeLine'>Type Line</Dropdown.Item>
        <Dropdown.Item eventKey='colors'>Colors</Dropdown.Item>
        <Dropdown.Item eventKey='manaValue'>Mana Value</Dropdown.Item>
        <Dropdown.Item eventKey='power'>Power</Dropdown.Item>
        <Dropdown.Item eventKey='toughness'>Toughness</Dropdown.Item>
        <Dropdown.Item eventKey='rarity'>Rarity</Dropdown.Item>
        <Dropdown.Item eventKey='sets'>Sets</Dropdown.Item>
        <Dropdown.Item eventKey='tags'>Tags</Dropdown.Item>
        <Dropdown.Item eventKey='price'>Price</Dropdown.Item>
        <Dropdown.Item eventKey='salt'>Salt</Dropdown.Item>
        <Dropdown.Item eventKey='num_decks'>Deck #</Dropdown.Item>
        <Dropdown.Item eventKey='inclusion'>Deck %</Dropdown.Item>
        <Dropdown.Item eventKey='synergy'>Synergy %</Dropdown.Item>
      </DropdownButton>
    </TooltipWrapper>
  )
}

export default AdditionalFiltersButton
